import React, { useCallback, useEffect, useState } from "react";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import classNames from "classnames";
import { CSVLink } from "react-csv";
import { format } from "date-fns";
import faker from "faker";
import { EmitterStatus } from "../../event";
import ReactExport from "react-data-export";
import { saveAs } from "file-saver";
import { SubmitLocalStorageSearch } from "../../function";
import {
  pdf,
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import font from "../../styles/CORDIA.ttf";
import fontBold from "../../styles/Cordia New Bold.ttf";

// REDUX
import { onChangeSearchBar } from "../../_redux/searchBarSlice";

// REDUX
import {} from "../../_redux/searchBarSlice";

// HOOKS
import useGetAllLoanRequest from "../../hooks/useGetAllLoanRequest";
import useGetLoanRequestCount from "../../hooks/useGetLoanRequestCount";

// COMPONENTS
import LoanRequestTableBackEnd from "./LoanRequestTableBackEnd";
import DataEmpty from "../DataEmpty";
import ContainerContent from "../Container/ContainerContent";
import LoadingPage from "../Loading/LoadingPage";
import PrevPage from "../../components/Pagination/PrevPage";
import NumberPage from "../../components/Pagination/NumberPage";
import NextPage from "../../components/Pagination/NextPage";
import LoadingMutation from "../../components/Loading/LoadingMutation";
import SelectRows from "../../components/Pagination/SelectRows";

// UTILS
import { pad, getCurrentLocalDateTime } from "../../utils/getLocalDateTime";

// AWS
import { API, Auth, Storage } from "aws-amplify";
import { data } from "autoprefixer";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Skeleton from "react-loading-skeleton";
import { checkRole } from "../../utils/role";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const optionsPackage = [
  {
    label: "All Package",
    value: "All",
  },
  {
    label: "อุปโภค / บริโภค",
    value: "อุปโภค / บริโภค",
  },
  {
    label: "ท่องเที่ยว",
    value: "ท่องเที่ยว",
  },
  {
    label: "ธุรกิจ",
    value: "ธุรกิจ",
  },
];

const optionsStatus = [
  {
    label: "All Status",
    value: "All",
  },
  {
    label: "รับคำร้อง",
    value: "รับคำร้อง", //WAIT APPROVE RETURN
  },
  {
    label: "รออนุมัติ",
    value: "รออนุมัติ", //WAIT APPROVE RETURN
  },
  {
    label: "รอผู้ยื่นคำร้องแก้ไข",
    value: "รอผู้ยื่นคำร้องแก้ไข", //WAIT APPROVE RETURN
  },
  {
    label: "รอติดต่อบุคคลอ้างอิง",
    value: "รอติดต่อบุคคลอ้างอิง",
  },
  {
    label: "อนุมัติ",
    value: "อนุมัติ",
  },
  {
    label: "ไม่ผ่าน",
    value: "ไม่ผ่าน",
  },
  {
    label: "ยืนยัน",
    value: "ยืนยัน",
  },
  {
    label: "สมบูรณ์",
    value: "สมบูรณ์",
  },
  {
    label: "สิ้นสุด",
    value: "สิ้นสุด",
  },
  {
    label: "โอนเงินไม่สำเร็จ",
    value: "โอนเงินไม่สำเร็จ",
  },
];

const optionsLimit = [
  {
    label: 50,
    value: 50,
  },
  { label: 100, value: 100 },
  { label: 150, value: 150 },
  { label: 200, value: 200 },
  { label: 250, value: 250 },
  { label: 300, value: 300 },
  // { label: 350, value: 350 },
  // { label: 400, value: 400 },
  // { label: 450, value: 450 },
  // { label: 500, value: 500 },
  // { label: 1000, value: 1000 },
];

const optionsReserve = [
  {
    label: "ทั้งหมด",
    value: "ALL",
  },
  { label: "จอง (แสดงเฉพาะของตัวเอง)", value: "RESERVE" },
  { label: "ยังไม่ได้จอง", value: "NOT_RESERVE" },
];

function LoanRequest() {
  const Limit = 50;
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.initializeApp);
  const searchBar = useSelector((state) => state.searchBar);

  const today = new Date();
  const max = new Date();

  max.setDate(max.getDate() + 3);

  const [checkSubmit, setCheckSubmit] = useState(false);

  const DEFAULT_QUERY = {
    Limit,
    countData: 1,
    request_id: "",
    ScanIndexForward: false,
    package: optionsPackage[0].value,
    status: optionsStatus[1].value,
    min: "",
    max: "",
    reserve: "NOT_RESERVE",
    reserveBy: "NOT_RESERVE",
  };

  const [currentType, setCurrentType] = useState("รับคำร้อง");
  const [countObj, setCountObj] = useState({
    All: 0,
    รับคำร้อง: 0,
    รออนุมัติ: 0,
    รอผู้ยื่นคำร้องแก้ไข: 0,
    รอติดต่อบุคคลอ้างอิง: 0,
    อนุมัติ: 0,
    ไม่ผ่าน: 0,
    ยืนยัน: 0,
    สมบูรณ์: 0,
    สิ้นสุด: 0,
    โอนเงินไม่สำเร็จ: 0,
  });

  const { datas, loading, error, getData, count } =
    useGetAllLoanRequest(DEFAULT_QUERY);
  const {
    datas: datasCount,
    loading: loadingCount,
    error: errorCount,
    getData: getDataCount,
  } = useGetLoanRequestCount({ ...DEFAULT_QUERY, setCountObj });
  // const {
  //   datas: datasCountAll,
  //   loading: loadingCountAll,
  //   error: errorCountAll,
  // } = useGetLoanRequestCount({
  //   ...DEFAULT_QUERY,
  //   status: "All",
  //   reserve: "ALL",
  //   reserveBy: "ALL",
  // });

  const [loadingReserve, setLoadingReserve] = useState(false);
  const [searchBy, setSearchBy] = useState("phone_number");
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState({ value: Limit, label: Limit });
  const [pageType, setPageType] = useState(null);
  const [loadingExportAll, setLoadingExportAll] = useState(false);
  const [dataAll, setDataAll] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [loadingExport, setLoadingExport] = useState(false);
  const [dataExport, setDataExport] = useState([]);
  const [type, setType] = useState("exportExcel");
  const [query, setQuery] = useState(DEFAULT_QUERY);
  const [ranCount, setRanCount] = useState(1);
  const [countCreate, setCountCreate] = useState(0);
  const [countExport, setCountExport] = useState(0);

  const [loadingRan, setLoadingRan] = useState(false);

  useEffect(() => {
    setCountExport(datasCount);
  }, [datasCount]);

  if (error) return <p className="text-black">Error</p>;

  const totalPage = Math.ceil(count / pageSize.value);
  const sliceNumber = 1;

  const paginationPages = new Array(1)?.fill(0)?.slice(0, sliceNumber);
  const canNextPage = pageIndex + 1 !== totalPage;
  const canPreviousPage = pageIndex !== 0;

  const onClickExport = () => {
    const exportClick = document.getElementById("loanRequest");
    exportClick.click();
  };

  const onClickExportAll = async () => {
    try {
      setLoadingExportAll(true);

      let keepData = [];

      let limit = 20;
      const cal_count = Math.ceil(countObj[currentType] / limit);
      let ExclusiveStartKey = "";
      for (let index = 0; index < cal_count; index++) {
        if (keepData.length > 0) {
          ExclusiveStartKey = getExclusiveStartKeyAll(
            keepData.length - 1,
            keepData
          );
        }
        const data = await API.get("MoneyHubAdmin", "/loanRequest/exportAll", {
          queryStringParameters: {
            ...query,
            Limit: 20,
            ScanIndexForward: false,
            ExclusiveStartKey,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        });
        keepData = [...keepData, ...data?.body.Items];
        setCountExport((prev) => (prev - limit < 0 ? 0 : prev - limit));
      }

      keepData = keepData?.filter((item) => {
        if (
          (item.loan_status === "รับคำร้อง" && item.adminName) ||
          item.isReturn
        ) {
          return;
        }

        return item;
      });

      setDataAll(keepData);
      const exportClick = document.getElementById("loanRequestExportAll");
      exportClick.click();
    } catch (error) {
      console.log("export all", error);
    } finally {
      setLoadingExportAll(false);
    }
  };

  function randomid() {
    var id12 = "";
    for (var i = 0; i < 12; i++) {
      id12 += parseInt(Math.random() * 10);
    }
    return id12 + finddigit(id12);
  }
  function finddigit(id) {
    var base = 100000000000; //สร้างตัวแปร เพื่อสำหรับให้หารเพื่อเอาหลักที่ต้องการ
    var basenow; //สร้างตัวแปรเพื่อเก็บค่าประจำหลัก
    var sum = 0; //สร้างตัวแปรเริ่มตัวผลบวกให้เท่ากับ 0
    for (var i = 13; i > 1; i--) {
      //วนรอบตั้งแต่ 13 ลงมาจนถึง 2
      basenow = Math.floor(id / base); //หาค่าประจำตำแหน่งนั้น ๆ
      id = id - basenow * base; //ลดค่า id ลงทีละหลัก
      sum += basenow * i; //บวกค่า sum ไปเรื่อย ๆ ทีละหลัก
      base = base / 10; //ตัดค่าที่ใช้สำหรับการหาเลขแต่ละหลัก
    }
    var checkbit = (11 - (sum % 11)) % 10; //คำนวณค่า checkbit
    return checkbit;
  }

  const randomBankNo = () => {
    var base = "";
    for (let index = 0; index < 10; index++) {
      const ranId = Math.floor(Math.random() * 9);
      base += `${ranId}`;
    }
    return base;
  };

  const randomLoanRequest = async () => {
    const default_data = {
      request_id: "LR0875003282_130964_1703530_1",
      bank: "ธนาคารไทยพาณิชย์(SCB)",
      dataDebt: "[]",
      garuntor: "{}",
      relation2: "หัวหน้างาน",
      garantorScore: 10,
      referalPhone: "0991121250",
      selfieUri: "lonrequest_0875003282_2021-09-13T09:30:17.975Z_selfie.jpeg",
      fileBuro: "1631527489359_07.jpg",
      businessContractUris: "[]",
      loan_kbank_id: "640000000130",
      adminName: "nantanon",
      burdenSum: "0",
      executeTime: 1631527491000,
      reserveBy: "nantanon",
      religion: "อื่น ๆ",
      payPerMonth: 6562.5,
      privillegeType: "ประเภทสิทธิพิเศษ",
      addressDesc: "ซอย 1150 ถนน 1120",
      marritalStatus: "โสด",
      refinance_id: "",
      latitude: "13.8173498",
      citizenid: "1127081853126",
      privillege: "",
      income: "35000",
      namePartner: "",
      timestamp: 1631550619000,
      articlePartner: "",
      burden: "8000",
      statementUris: '["0875003282dummy.pdf"]',
      address: "จันทรเกษม,จตุจักร,กรุงเทพมหานคร,10900",
      job_score: 44,
      creditUri: "",
      officialAddressCode: "1234",
      bookbankUri:
        "lonrequest_0875003282_2021-09-13T09:30:17.975Z_bookbank.jpeg",
      reason: "",
      pdpaUri: "LR0875003282_130964_1630_1_pdpa.pdf",
      education: "ปริญญาตรี",
      longitude: "100.5807779",
      phone_number: "0875003282",
      amount: 8000,
      birthdateTh: "01/04/2530",
      promo: 0,
      bankAccName: "Carrie O'Hara Nader",
      status_score: 70,
      verify: "true",
      deviceToken:
        "freKn6gEQIqv02PmV8TjXo:APA91bE4wbXJBYPCQWdwG536lCO9sNSnYgyYAG5Ow3eZW0XY6ySYqq-09JFPy1-Eru8QBKpVDgsuhcr5zZmMlFJ3L69lkebesT3wx6ptw4ck_iEJVEUZ4ZS-U_J1QuD6o53NoCUIJpQY",
      purpose: "ธุรกิจ",
      officialAddressDesc: "ซอย 123 ถนน 321",
      requestamount: 8000,
      job_address: "",
      jobposition: "พนักงานทั่วไป",
      relation: "หัวหน้างาน",
      tx: "",
      totalScore: 86.49999999999999,
      lastnamePartner: "",
      addressUri: "lonrequest_0875003282_2021-09-13T09:30:17.975Z_address.jpeg",
      period: 12,
      email: "Test@gmail.com",
      paydate: "2021-09-16T10:04:09.228Z",
      name: "Carrie O'Hara",
      pass: "true",
      penaltytime: 0,
      careertype: "พนักงานเอกชน",
      jobAge: 8,
      beginjobdate: "01/01/2564",
      currentAddress: "คลองเจ้าคุณสิงห์,วังทองหลาง,กรุงเทพมหานคร,10310",
      company: "ทดสอบ01",
      job_phone: "",
      citizenexpiredate: "01/01/2564",
      financial_score: 89.5,
      referal_two: true,
      age: 34,
      citizenUri:
        '["lonrequest_0875003282_2021-09-13T09:30:17.975Z_citizen_1.jpeg"]',
      slipUris:
        '["lonrequest_0875003282_2021-09-13T09:30:17.975Z_slip_0.jpeg"]',
      requestTime: "2021-09-13T17:03:53",
      childern: "ไม่มีบุตร",
      passwordPdf: "01011990",
      article: "นาย",
      buro: "ประวัติการชำระเงินดี",
      referalPhone2: "0991121250",
      dueTime: "2021-09-13T17:03:53",
      gender: "ชาย",
      lastname: "Nader",
      addressCode: "1212",
      loan_status: "ยืนยัน",
      referalName: "ทดสอบ",
      bankNo: "7381218827",
      referal_one: true,
      contractUri: "LR0875003282_130964_1630_1_contract.pdf",
      dataAsset: "[]",
      lineid: "Testline",
      sendSap: "false",
      referalName2: "ทดสอบ2",
    };
    const ranRequestAmountList = [
      5000, 6000, 7000, 8000, 9000, 10000, 15000, 20000, 30000, 50000,
      // 10000,
    ];
    const ranPeriodList = [3, 6, 12];
    // const ranPeriodList = [3];
    const ranPurposeList = ["ธุรกิจ", "อุปโภค / บริโภค", "ท่องเที่ยว"];
    // const ranPurposeList = ["ท่องเที่ยว"];
    const ranStatusList = [
      "รับคำร้อง",
      // "รออนุมัติ",
      // "รอผู้ยื่นคำร้องแก้ไข",
      // "รอติดต่อบุคคลอ้างอิง",
      // "อนุมัติ",
      // "ไม่ผ่าน",
      // "ยืนยัน",
      // "สมบูรณ์",
      // "สิ้นสุด",
    ];

    setLoadingRan(true);
    for (let index = 0; index < ranCount; index++) {
      const ranRequestAmountIndex = Math.floor(
        Math.random() * ranRequestAmountList.length
      );
      const ranPeriodIndex = Math.floor(Math.random() * ranPeriodList.length);
      const ranPurposeIndex = Math.floor(Math.random() * ranPurposeList.length);
      const ranStatusIndex = Math.floor(Math.random() * ranStatusList.length);

      const fakerName = faker.name.findName();
      const fakerLastName = faker.name.lastName();
      const phone_number = "0875003282";
      const today = getCurrentLocalDateTime(new Date());
      const request_id = `LR${phone_number}_${pad(today.date)}${pad(
        today.month
      )}${(+today.year + 543).toString().slice(-2)}_${pad(today.hours)}${pad(
        today.minutes
      )}${pad(today.seconds + index)}_${ranPurposeIndex + 1}`;

      const splitName =
        fakerName.split(" ").length > 0 ? fakerName.split(" ")[0] : fakerName;

      const newData = {
        ...default_data,
        bankAccName: `${splitName} ${fakerLastName}`,
        fullname: `${splitName} ${fakerLastName}`,
        citizenid: randomid(),
        bankNo: randomBankNo(),
        timestamp: today.timestamp,
        dueTime: today.isoDateTime,
        requestTime: today.isoDateTime,
        executeTime: today.timestamp,
        name: splitName,
        lastname: fakerLastName,
        loan_status: "รับคำร้อง",
        request_id,
        phone_number,
        period: ranPeriodList[ranPeriodIndex],
        requestamount: ranRequestAmountList[ranRequestAmountIndex],
        amount: ranRequestAmountList[ranRequestAmountIndex],
        purpose: ranPurposeList[ranPurposeIndex],
        phone_number: "0877908161",
      };

      await API.post("MoneyHubAdmin", "/loanRequest", {
        body: {
          ...newData,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
      setCountCreate((prev) => prev + 1);
    }
    setLoadingRan(false);
    await getData(query);
  };

  const onClickResetFilter = async () => {
    setQuery(DEFAULT_QUERY);
    dispatch(onChangeSearchBar(""));
    setSearchBy("phone_number");
    setPageIndex(0);
    setPageType(null);
    await getData(DEFAULT_QUERY);
    await getDataCount(DEFAULT_QUERY);
  };

  const onChangeLimit = async (e) => {
    setPageSize(e);
    setPageIndex(0);
    let newQuery = {
      ...query,
      Limit: e.value,
    };
    delete newQuery?.ExclusiveStartKey;
    setQuery(newQuery);
    await getData(newQuery);
  };

  const onSelect = (name) => (e) => {
    const { value } = e;
    setQuery((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const onSelectReservie = (e) => {
    const { value } = e;

    let reserveBy = "ALL";

    if (value === "RESERVE") {
      reserveBy = user.username;
    } else if (value === "NOT_RESERVE") {
      reserveBy = "NOT_RESERVE";
    }
    console.log("reserveBy", reserveBy);

    setQuery((prev) => {
      return {
        ...prev,
        reserve: value,
        reserveBy,
      };
    });
  };

  const onField = (e) => {
    const { name, value } = e.target;
    setQuery((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const getExclusiveStartKey = (index) => {
    if (query.request_id) {
      return `request_id=${datas[index].request_id}&verify=true&loan_kbank_id=${datas[index].loan_kbank_id}`;
    } else if (query.name) {
      return `request_id=${datas[index].request_id}&verify=true&name=${datas[index].name}`;
    } else if (query.requestamount) {
      return `request_id=${datas[index].request_id}&verify=true&requestamount=${datas[index].requestamount}`;
    } else if (query.phone_number) {
      return `request_id=${datas[index].request_id}&verify=true&phone_number=${datas[index].phone_number}`;
    }
    return `request_id=${datas[index].request_id}&verify=true&loan_status=${datas[index].loan_status}&timestamp=${datas[index].timestamp}`;
  };

  const getExclusiveStartKeyAll = (index, datas = []) => {
    if (query.request_id) {
      return `request_id=${datas[index].request_id}&verify=true&loan_kbank_id=${datas[index].loan_kbank_id}`;
    } else if (query.name) {
      return `request_id=${datas[index].request_id}&verify=true&name=${datas[index].name}`;
    } else if (query.requestamount) {
      return `request_id=${datas[index].request_id}&verify=true&requestamount=${datas[index].requestamount}`;
    } else if (query.phone_number) {
      return `request_id=${datas[index].request_id}&verify=true&phone_number=${datas[index].phone_number}`;
    }
    return `request_id=${datas[index].request_id}&verify=true&loan_status=${datas[index].loan_status}&timestamp=${datas[index].timestamp}`;
  };

  const onClickPrevPage = async () => {
    let newQuery = {
      ...query,
      Limit: +pageSize.value,
      countData: 1,
      ScanIndexForward: true,
    };
    if (pageType === "NEXT" && !datas.length) {
      newQuery = {
        ...newQuery,
      };
    } else {
      newQuery = {
        ...newQuery,
        ExclusiveStartKey: getExclusiveStartKey(0),
      };
    }
    setPageIndex((prev) => prev - 1);
    setPageType("PREV");
    await getData(newQuery, { sortBy: true });
  };

  const onClickNextPage = async () => {
    const lastIndex = datas.length - 1;
    const newQuery = {
      ...query,
      countData: 1,
      ScanIndexForward: false,
      Limit: +pageSize.value,
      ExclusiveStartKey: getExclusiveStartKey(lastIndex),
    };
    setPageIndex((prev) => prev + 1);
    setPageType("NEXT");
    await getData(newQuery);
  };

  const getDefaultPayDate = (days = 3) => {
    let result = new Date();
    result.setDate(result.getDate() + days);
    return result;
  };

  const onClickCompleteSelected = async () => {
    try {
      const result = await Swal.fire({
        title: "คุณยืนยันที่จะทำรายการหรือไม่?",
        showCancelButton: true,
        confirmButtonText: `บันทึก`,
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        showLoaderOnDeny: false,
        preConfirm: async () => {
          for (const row of selectedRows) {
            const { original } = row;
            let executeTime = getCurrentLocalDateTime();
            await API.put("MoneyHubAdmin", "/loanRequest", {
              body: {
                request_id: original.request_id,
                phone_number: original.phone_number, //WHERE KEY 1
                timestamp: original.timestamp, //WHERE KEY 2
                fileBuro: "",
                reason: "",
                status: "อนุมัติ",
                // status: "ยืนยัน",
                referal_one: original.referal_one,
                referal_two: original.referal_two,
                paydate: getDefaultPayDate(),
                adminName: user.username,
                executeTime: executeTime.timestamp,
              },
              headers: {
                Authorization: `Bearer ${(await Auth.currentSession())
                  .getIdToken()
                  .getJwtToken()}`,
              },
            });
          }
        },
      });
      if (!result.isConfirmed) return;
      await Swal.fire({
        title: "SUCCESS",
        text: "อัพเดตข้อมูลสำเร็จ",
        icon: "success",
        confirmButtonText: "ยืนยัน",
      });
      await getData(query);
    } catch (error) {
      await Swal.fire({
        title: "ERROR",
        text: "อัพเดตข้อมูลไม่สำเร็จ",
        icon: "error",
        confirmButtonText: "ยืนยัน",
      });
      return console.log("Update error :", error);
    }
  };

  const onClickExportExcel = async () => {
    setLoadingExport(true);
    const data = await API.get("MoneyHubAdmin", "/exportExcel", {
      queryStringParameters: {
        TableName: "loan_request",
      },
      headers: {
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    });

    toast.success("ข้อมูลของคุณพร้อมแล้ว!");
    const parseData = JSON.parse(data.body);
    setDataExport(parseData.Items);
    setLoadingExport(false);
  };

  const onSubmitFilter = async () => {
    SubmitLocalStorageSearch(searchBar);
    setPageIndex(0);
    setPageType(null);
    let newQuery = {
      ...query,
    };
    delete newQuery?.request_id;
    delete newQuery?.name;
    delete newQuery?.adminName;
    delete newQuery?.requestamount;
    delete newQuery?.phone_number;
    if (searchBar.value) {
      newQuery = {
        ...newQuery,
        [searchBy]: searchBar.value,
      };
    }
    // else {
    //   delete newQuery?.request_id;
    //   delete newQuery?.name;
    //   delete newQuery?.adminName;
    //   delete newQuery?.requestamount;
    //   delete newQuery?.phone_number;
    // }
    delete newQuery?.ExclusiveStartKey;
    setCurrentType(newQuery.status);
    setQuery(newQuery);
    await getData(newQuery);
    await getDataCount(newQuery);
  };

  const refresh = async () => {
    let newQuery = {
      ...query,
    };
    await getData(newQuery);
    await getDataCount(newQuery);
  };

  const onReserve = (status) => async (e) => {
    try {
      setLoadingReserve(true);
      const result = await Swal.fire({
        title: "คุณยืนยันที่จะทำรายการหรือไม่?",
        showCancelButton: true,
        confirmButtonText: `บันทึก`,
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        showLoaderOnDeny: false,
        preConfirm: async () => {
          try {
            for (const row of selectedRows) {
              const { original } = row;
              await API.put(
                "MoneyHubAdmin",
                `/loanRequest/reserve/${original.request_id}`,
                {
                  body: {
                    reserveBy: status === "reserve" ? user.username : "",
                    adminName: user.username,
                  },
                  headers: {
                    Authorization: `Bearer ${(await Auth.currentSession())
                      .getIdToken()
                      .getJwtToken()}`,
                  },
                }
              );
            }
          } catch (error) {
            await EmitterStatus("ERROR", { logMessage: error });
          }
        },
      });
      if (!result.isConfirmed) return;
      await EmitterStatus("SUCCESS");
      await getData(query);
    } catch (error) {
      await EmitterStatus("ERROR", { logMessage: error });
    } finally {
      setLoadingReserve(false);
    }
  };

  const getOption = (options, value) => {
    const findIndex = options.findIndex((option) => option.value === value);
    return options[findIndex];
  };

  const getCountDown = (value) => {
    // Get today's date and time
    var now = new Date().getTime();

    // Find the distance between now and the count down date
    var distance = value - now;

    // Time calculations for days, hours, minutes and seconds
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // Display the result in the element with id="demo"
    return (
      pad(checkLessZero(days)) +
      ":" +
      pad(checkLessZero(hours)) +
      ":" +
      pad(checkLessZero(minutes)) +
      ":" +
      pad(checkLessZero(seconds))
    );
  };

  const checkLessZero = (number) => {
    return number < 0 ? "00" : number;
  };

  const createDataWithStyle = (data = []) => {
    var result = [];
    const borders = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    const style = {
      font: { sz: 14 },
      alignment: { vertical: "center", horizontal: "center" },
      // border: borders,
    };

    for (let i = 0; i < data.length; i++) {
      result.push([
        {
          value: data[i].original.phone_number,
          style,
        },
        {
          value: data[i].original.loan_kbank_id,
          style,
        },
        {
          value: data[i].original.name,
          style,
        },
        {
          value: data[i].original.requestamount,
          style,
        },
        {
          value: data[i].original.amount,
          style,
        },
        {
          value: data[i].original.purpose,
          style,
        },
        {
          value: data[i].original.purposeDetail || "-",
          style,
        },
        {
          value: data[i].original.timestamp
            ? format(new Date(data[i].original.timestamp), "dd-MM-yyyy")
            : "-",
          style,
        },
        {
          value: data[i].original.executeTime
            ? format(new Date(data[i].original.executeTime), "dd-MM-yyyy")
            : "-",
          style,
        },
        {
          value: data[i].original.loan_status,
          style,
        },
        {
          value: getCountDown(
            Date.now() +
              (new Date(data[i].original.dueTime).getTime() - Date.now())
          ),
          style,
        },
        {
          value: data[i].original.reserveBy || "",
          style,
        },
        {
          value: data[i].original.adminName || "",
          style,
        },
        {
          value: data[i].original.completedAt
            ? format(new Date(data[i].original.completedAt), "dd-MM-yyyy")
            : "-",
          style,
        },
        {
          value: data[i].original.completedBy || "-",
          style,
        },
        {
          value: data[i].original.approvedAt
            ? format(new Date(data[i].original.approvedAt), "dd-MM-yyyy")
            : "-",
          style,
        },
        {
          value: data[i].original.approvedBy || "-",
          style,
        },
      ]);
    }
    return result;
  };

  const createDataWithStyleAll = (data = []) => {
    var result = [];
    const borders = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    const style = {
      font: { sz: 14 },
      alignment: { vertical: "center", horizontal: "center" },
      // border: borders,
    };

    for (let i = 0; i < data.length; i++) {
      result.push([
        {
          value: data[i]?.phone_number || "",
          style,
        },
        {
          value: data[i]?.loan_kbank_id || "",
          style,
        },
        {
          value: data[i]?.name || "",
          style,
        },
        {
          value: data[i]?.requestamount || "",
          style,
        },
        {
          value: data[i]?.amount || "",
          style,
        },
        {
          value: data[i]?.purpose || "",
          style,
        },
        {
          value: data[i]?.purposeDetail || "-",
          style,
        },
        {
          value: data[i]?.timestamp
            ? format(new Date(data[i]?.timestamp), "dd-MM-yyyy")
            : "-",
          style,
        },
        {
          value: data[i]?.executeTime
            ? format(new Date(data[i]?.executeTime), "dd-MM-yyyy")
            : "-",
          style,
        },
        {
          value: data[i]?.loan_status || "",
          style,
        },
        {
          value: getCountDown(
            Date.now() + (new Date(data[i]?.dueTime).getTime() - Date.now())
          ),
          style,
        },
        {
          value: data[i]?.reserveBy || "",
          style,
        },
        {
          value: data[i]?.adminName || "",
          style,
        },
        {
          value:
            data[i].completedAt && data[i].completedBy
              ? format(new Date(data[i].completedAt), "dd-MM-yyyy")
              : "-",
          style,
        },
        {
          value:
            data[i].completedAt && data[i].completedBy
              ? data[i].completedBy
              : "-",
          style,
        },
        {
          value:
            data[i].approvedAt && data[i].approvedBy
              ? format(new Date(data[i].approvedAt), "dd-MM-yyyy")
              : "-",
          style,
        },
        {
          value:
            data[i].approvedAt && data[i].approvedBy ? data[i].approvedBy : "-",
          style,
        },
      ]);
    }
    return result;
  };

  const style = {
    font: { sz: 16, name: "Cordia New" },
    alignment: { vertical: "center", horizontal: "center" },
    // border: borderColumn,
  };

  const sameColumn = [
    {
      title: "เบอร์โทร",
      width: { wch: 38 },
      style,
    }, //p
    {
      title: "Job no",
      width: { wch: 28 },
      style,
    }, //pixels width
    {
      title: "ชื่อ",
      width: { wch: 38 },
      style,
    }, //pixels width
    {
      title: "วงเงินที่ได้",
      width: { wch: 24 },
      style,
    }, //char width
    {
      title: "วงเงินที่ขอ",
      width: { wch: 24 },
      style,
    },
    {
      title: "ประเภทสินเชื่อ",
      width: { wch: 24 },
      style,
    },
    {
      title: "วัตถุประสงค์",
      width: { wch: 30 },
      style,
    },
    {
      title: "วันที่สร้าง",
      width: { wch: 24 },
      style,
    },
    {
      title: "วันที่แก้ไข",
      width: { wch: 24 },
      style,
    },
    {
      title: "สถานะ",
      width: { wch: 24 },
      style,
    },
    {
      title: "Time Remain",
      width: { wch: 36 },
      style,
    },
    {
      title: "จองโดย",
      width: { wch: 24 },
      style,
    },
    {
      title: "แก้ไขโดย",
      width: { wch: 24 },
      style,
    },
    {
      title: "Complete Date",
      width: { wch: 24 },
      style,
    },
    {
      title: "Complete By",
      width: { wch: 24 },
      style,
    },
    {
      title: "Approve Date",
      width: { wch: 24 },
      style,
    },
    {
      title: "Approved By",
      width: { wch: 24 },
      style,
    },
  ];

  const multiDataSet = [
    {
      columns: sameColumn,
      data: createDataWithStyle(selectedRows),
    },
  ];

  const multiDataSetAll = [
    {
      columns: sameColumn,
      data: createDataWithStyleAll(dataAll),
    },
  ];

  const onSearchBy = (value) => {
    setSearchBy(value);
  };

  return (
    <ContainerContent>
      <div className="mx-6 w-full mb-2 lg:flex items-center">
        <div className="">
          ค้นหาโดยใช้&nbsp;
          <label class="inline-flex items-center lg:ml-2">
            <input
              onChange={() => onSearchBy("request_id")}
              type="radio"
              class="form-radio"
              name="search"
              defaultChecked={true}
              checked={searchBy === "request_id"}
            />
            <span class="ml-2">Job. No.</span>
          </label>
          <label class="inline-flex items-center ml-2">
            <input
              onChange={() => onSearchBy("name")}
              type="radio"
              class="form-radio"
              name="search"
              checked={searchBy === "name"}
            />
            <span class="ml-2">ชื่อ - นามสกุล</span>
          </label>
          <label class="inline-flex items-center ml-2">
            <input
              onChange={() => onSearchBy("requestamount")}
              type="radio"
              class="form-radio"
              name="search"
              checked={searchBy === "requestamount"}
            />
            <span class="ml-2">วงเงินที่ได้</span>
          </label>
          <label class="inline-flex items-center ml-2">
            <input
              onChange={() => onSearchBy("adminName")}
              type="radio"
              class="form-radio"
              name="search"
              checked={searchBy === "adminName"}
            />
            <span class="ml-2">ชื่อแอดมิน</span>
          </label>
          <label class="inline-flex items-center ml-2">
            <input
              onChange={() => onSearchBy("phone_number")}
              type="radio"
              class="form-radio"
              name="search"
              checked={searchBy === "phone_number"}
            />
            <span class="ml-2">เบอร์โทร</span>
          </label>
          <label class="inline-flex items-center ml-2">
            <input
              onChange={() => onSearchBy("citizenid")}
              type="radio"
              class="form-radio"
              name="search"
              checked={searchBy === "citizenid"}
            />
            <span class="ml-2">บัตรประชาชน</span>
          </label>
          <div className="flex items-center mt-4">
            {user?.groups?.some((group) =>
              ["SuperAdmin", "ApproveSupervisor"].includes(group)
            ) && (
              <button
                disabled={!selectedRows.length}
                className={classNames(
                  " border p-1 px-2 rounded  duration-300 hover:text-white",
                  {
                    "bg-gray-300 cursor-not-allowed text-white":
                      !selectedRows.length,
                    "border-green-500 p-1 px-2 rounded text-green-500 hover:bg-green-600 hover:text-white":
                      selectedRows.length,
                  }
                )}
                onClick={onClickCompleteSelected}
              >
                Complete All
              </button>
            )}
            <ToastContainer
              position="top-center"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
            <ExcelFile
              filename={`LOAN_REQUEST${format(new Date(), "yyyy-MM-dd")}`}
              element={<button id="loanRequest" hidden></button>}
            >
              <ExcelSheet
                dataSet={multiDataSet}
                name="LOAN REQUEST"
              ></ExcelSheet>
            </ExcelFile>
            {/* <button
              disabled={!selectedRows.length}
              className={classNames(
                "ml-2 border p-1 px-2 rounded duration-300 hover:text-white",
                {
                  "bg-gray-300 cursor-not-allowed text-white":
                    !selectedRows.length,
                  "text-white bg-green-500 border-green-500 hover:bg-green-600":
                    selectedRows.length,
                }
              )}
              onClick={() => generatePdfDocument(true)}
            >
              ซองจดหมาย
            </button> */}
            <button
              disabled={!selectedRows}
              className={classNames(
                "ml-2 border p-1 px-2 rounded  duration-300 hover:text-white",
                {
                  "bg-gray-300 cursor-not-allowed text-white":
                    !selectedRows.length,
                  "border-green-500 p-1 px-2 rounded text-white hover:bg-green-600 bg-green-500  hover:text-white":
                    selectedRows.length,
                }
              )}
              onClick={onClickExport}
            >
              Export Excel
            </button>
            <ExcelFile
              filename={`LOAN_REQUEST_ALL${format(new Date(), "yyyy-MM-dd")}`}
              element={<button id="loanRequestExportAll" hidden></button>}
            >
              <ExcelSheet
                dataSet={multiDataSetAll}
                name="LOAN REQUEST"
              ></ExcelSheet>
            </ExcelFile>
            <button
              disabled={loadingExportAll || loadingCount}
              className={classNames(
                "ml-2 border p-1 px-2 rounded  duration-300 hover:text-white",
                {
                  "bg-gray-300 cursor-not-allowed text-white":
                    loadingExportAll || loadingCount,
                  "border-green-500 p-1 px-2 rounded text-white hover:bg-green-600 bg-green-500  hover:text-white":
                    !loadingExportAll || loadingCount,
                }
              )}
              onClick={onClickExportAll}
            >
              {(loadingExportAll || loadingCount) && (
                <svg
                  className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx={12}
                    cy={12}
                    r={10}
                    stroke="currentColor"
                    strokeWidth={4}
                  />
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  />
                </svg>
              )}
              Export Excel All ({countObj[currentType]})
            </button>
            {/* <CSVLink
              disabled={!selectedRows.length}
              headers={headers}
              data={dataCsv}
              filename={`LOAN_REQUEST_${format(new Date(), "dd-MM-yyyy")}.xls`}
            >
              <button
                className={classNames(
                  "ml-2 border p-1 px-2 rounded  duration-300 hover:text-white",
                  {
                    "bg-gray-300 cursor-not-allowed text-white":
                      !selectedRows.length,
                    "border-green-500 p-1 px-2 rounded text-white hover:bg-green-600 bg-green-500  hover:text-white":
                      selectedRows.length,
                  }
                )}
              >
                Export Excel
              </button>
            </CSVLink> */}
            <div className="flex flex-row  ml-4">
              <div className="w-52">
                <Select
                  defaultValue={optionsReserve[2]}
                  value={getOption(optionsReserve, query.reserve)}
                  options={optionsReserve}
                  onChange={onSelectReservie}
                />
              </div>

              {checkRole(user?.groups, [
                "SuperAdmin",
                "ApproveSupervisor",
                "AnalyzeApprove",
                "ApproveStaff"
              ]) && (
                <React.Fragment>
                  <button
                    disabled={!selectedRows.length || loadingReserve}
                    className={classNames(
                      "ml-2 border p-1 px-2 rounded w-24 duration-300",
                      {
                        "bg-gray-300 cursor-not-allowed text-white":
                          !selectedRows.length || loadingReserve,
                        "border-yellow-400 p-1 px-2 rounded text-white hover:bg-yellow-600 bg-yellow-400  hover:text-white":
                          selectedRows.length && !loadingReserve,
                      }
                    )}
                    onClick={onReserve("reserve")}
                  >
                    จอง
                  </button>
                  <button
                    disabled={!selectedRows.length || loadingReserve}
                    className={classNames(
                      "ml-2 border p-1 px-2 rounded w-24 duration-300",
                      {
                        "bg-gray-300 cursor-not-allowed text-white":
                          !selectedRows.length || loadingReserve,
                        "border-yellow-400 p-1 px-2 rounded text-yellow-400 hover:bg-yellow-400 hover:text-white":
                          selectedRows.length && !loadingReserve,
                      }
                    )}
                    onClick={onReserve("cancel")}
                  >
                    ยกเลิกจอง
                  </button>
                </React.Fragment>
              )}
            </div>
            {/* จำนวนสร้าง {countCreate}
            <button
              disabled={loadingRan}
              className={classNames(
                "border p-1 px-2 rounded  duration-300 hover:text-white border-green-500 p-1 px-2 rounded text-green-500 hover:bg-green-600 hover:text-white"
              )}
              onClick={randomLoanRequest}
            >
              {loadingRan ? "Loading..." : "Random"}
            </button>
            <input
              disabled={loadingRan}
              className="border boder-gray-300 p-2 ml-4"
              type="number"
              value={ranCount}
              onChange={(e) => setRanCount(e.target.value)}
            />
            จำนวน Random */}
          </div>
        </div>
      </div>
      <div className="mx-6 w-full mt-2 mb-2 lg:flex items-center">
        <div className="lg:flex items-center ">
          <input
            name="min"
            value={query.min}
            onChange={onField}
            type="date"
            className="p-2 py-1 border rounded shadow-sm"
          />
        </div>
        <div className="lg:flex items-center lg:ml-0">
          <div className="lg:ml-2 mr-2">To</div>
          <input
            name="max"
            value={query.max}
            onChange={onField}
            type="date"
            className="p-2 py-1 border rounded shadow-sm"
          />
        </div>

        <div className="lg:ml-2 w-52 my-1">
          <Select
            defaultValue={optionsStatus[0]}
            value={getOption(optionsStatus, query.status)}
            options={optionsStatus}
            onChange={onSelect("status")}
          />
        </div>
        <div className="my-1 lg:my-0 lg:ml-2 w-52">
          <Select
            defaultValue={optionsPackage[0]}
            value={getOption(optionsPackage, query.package)}
            options={optionsPackage}
            onChange={onSelect("package")}
          />
        </div>

        <button
          className="ml-2 border border-blue-500 p-1 px-2 rounded text-blue-500 hover:bg-blue-600 duration-300 hover:text-white"
          onClick={onSubmitFilter}
        >
          Submit
        </button>
        <button
          className="ml-2 p-1 px-2 border border-red-500  rounded text-red-500 hover:bg-red-200 duration-300 hover:text-white"
          onClick={onClickResetFilter}
        >
          Clear
        </button>
        <svg
          onClick={refresh}
          xmlns="http://www.w3.org/2000/svg"
          className="h-9 w-9 rounded border border-gray-500 hover:bg-gray-200 text-gray-700 ml-2 p-2"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
          />
        </svg>
      </div>
      {loading ? (
        <ContainerContent>
          <LoadingPage />
        </ContainerContent>
      ) : !datas.length ? (
        pageType === "NEXT" ? (
          <ContainerContent>
            <div className="text-gray-700 font-bold text-xl w-full text-center mt-20">
              สิ้นสุดรายการ
            </div>
            <div className="w-full mt-2 flex items-center">
              {" "}
              <button
                className="bg-blue-500 text-xl p-4  mx-auto text-white mt-2 "
                onClick={onClickPrevPage}
              >
                ย้อนกลับ
              </button>
            </div>
          </ContainerContent>
        ) : (
          <ContainerContent>
            <DataEmpty />
          </ContainerContent>
        )
      ) : (
        <div>
          {" "}
          <div className="flex w-full p-4 pt-0">
            <div className="my-auto w-full flex">
              {loadingCount ? (
                <div className="w-12 mr-2">
                  <Skeleton />
                </div>
              ) : (
                countObj[currentType]
              )}{" "}
              Records
            </div>
            <div className=" flex justify-between gap-4 ">
              <nav
                className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px"
                aria-label="Pagination"
              >
                <PrevPage
                  canPreviousPage={pageIndex !== 0}
                  onClick={onClickPrevPage}
                />
                {paginationPages.map((_, i) => {
                  return (
                    <NumberPage number={pageIndex} pageIndex={pageIndex} />
                  );
                })}
                <NextPage onClick={onClickNextPage} canNextPage={true} />
              </nav>
              <div className="w-24 flex">
                <SelectRows
                  pageSize={pageSize}
                  onChange={onChangeLimit}
                  options={optionsLimit}
                />
              </div>
            </div>
          </div>
          <LoanRequestTableBackEnd
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            data={datas}
            getData={getData}
            query={query}
          />
        </div>
      )}
    </ContainerContent>
  );
}

export default LoanRequest;
